import React, { PureComponent } from 'react';
import './TextBlink.scss';
import moment from 'moment';
import {
  getColorPrice,
  getIconPriceFollowReferencePrice,
} from '../../../../helpers/Color';
import { formatTextFloat, formatPercent } from '../../../../helpers/Text';

const ANIMATION_TIME = 700;
const BLINK_DELAY = 1000;
const RATIO = 0.7;

class TextBlinkMalarquee extends PureComponent {
  constructor(props) {
    super(props);
    this.startDate = moment();
    this.state = {
      isBlink: false,
    };
  }

  componentDidMount() {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: RATIO,
    };

    this.observer = new IntersectionObserver(this.observer, options);
    this.observer.observe(this.div);
  }

  observer = entries => {
    const [data] = entries;
    if (data.intersectionRatio >= RATIO) {
      this.setState({
        isBlink: true,
      });
    }
  };

  checkDelayBlink = () => {
    const currentDate = moment();
    const diffMillisecond = currentDate.diff(this.startDate, 'millisecond');

    if (diffMillisecond < BLINK_DELAY) {
      return true;
    }
    this.startDate = currentDate;
    return false;
  };

  addClassChild = classColor => {
    const { className } = this.props;

    if (this.checkDelayBlink()) {
      return;
    }

    if (!this.div) {
      return;
    }
    this.div.childNodes.forEach(function(item, i) {
      if (i > 0) {
        item.classList.add(classColor);
        item.classList.add('transition');

        if (className) {
          item.classList.remove(className);
        }
        item.classList.add('text-white-all');

        item.blinkTimeout = setTimeout(() => {
          item.classList.remove(classColor);
          item.classList.remove('transition');

          if (item) {
            item.classList.remove('text-white-all');
            if (className) {
              item.classList.add(className);
            }
          }
        }, ANIMATION_TIME);
      }
    });
  };

  componentDidUpdate(prevProps, prevState) {
    const { data } = this.props;
    if (
      Object.keys(data).length &&
      Object.keys(prevProps.data).length &&
      data !== prevProps.data
    ) {
      if (this.props.data.value > prevProps.data.value) {
        this.addClassChild('bg-l-color-9');
      } else if (this.props.data.value < prevProps.data.value) {
        this.addClassChild('bg-s-color-3');
      }
    }
  }

  componentWillUnmount() {
    clearTimeout(this.blinkTimeout);
  }

  formatText = text => {
    const { data } = this.props;
    return data.value === 0 ? '--' : text;
  };

  render() {
    const { data } = this.props;
    const colorIndex = getColorPrice(
      data.value,
      data.referencePrice,
      data.ceilingPrice,
      data.floorPrice,
    );
    const classNameIndexValue = `number fs-16 mr-5 ` + colorIndex;
    const classIconCaret =
      colorIndex +
      ` fs-10  ` +
      getIconPriceFollowReferencePrice(data.value, data.referencePrice);
    return (
      <div ref={el => (this.div = el)} className="item-content">
        <strong className="id-trade fs-16 mr-5 text-uppercase">
          {data.code}{' '}
        </strong>
        <span className={classNameIndexValue}>
          {this.formatText(formatTextFloat(data.value))}{' '}
          <i className={classIconCaret} />
          <span className={classNameIndexValue}>
            {this.formatText(formatTextFloat(data.valueChange))}{' '}
          </span>
          <span className="number-per fs-16 text-percent-index-change">
            {this.formatText(formatPercent(data.percentChange))}%
          </span>
        </span>
      </div>
    );
  }
}

TextBlinkMalarquee.defaultProps = {
  className: 'text-blink',
  data: {},
};

export default TextBlinkMalarquee;
